var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6001 4.2666H6.40006C5.22139 4.2666 4.26672 5.22127 4.26672 6.39994V25.5999C4.26672 26.7786 5.22139 27.7333 6.40006 27.7333H25.6001C26.7787 27.7333 27.7334 26.7786 27.7334 25.5999V6.39994C27.7334 5.22127 26.7787 4.2666 25.6001 4.2666ZM11.6843 23.4666H8.53766V13.3418H11.6843V23.4666ZM10.079 11.8943C9.06459 11.8943 8.24432 11.0719 8.24432 10.0597C8.24432 9.0474 9.06566 8.22607 10.079 8.22607C11.0902 8.22607 11.9126 9.04847 11.9126 10.0597C11.9126 11.0719 11.0902 11.8943 10.079 11.8943ZM23.471 23.4666H20.3265V18.5429C20.3265 17.3685 20.3051 15.8581 18.6913 15.8581C17.0539 15.8581 16.8022 17.137 16.8022 18.4575V23.4666H13.6577V13.3418H16.6763V14.7253H16.719C17.1393 13.9295 18.1654 13.0901 19.6961 13.0901C22.8822 13.0901 23.471 15.1871 23.471 17.9135V23.4666Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b01dbd6a6d6a8ddb30ab40ee2f44b2ff.svg";
export { ForwardRef as ReactComponent };